var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDinoTriste(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 113,
    viewBox: "0 0 97 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.1646,
    y: 50.7834,
    width: 60,
    height: 60,
    transform: "rotate(-19.5941 14.1646 50.7834)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1459 33.4709L19.7868 49.9732C17.6532 50.7327 16.5393 53.0781 17.2988 55.2117L33.8011 101.571C34.5606 103.704 36.906 104.818 39.0396 104.059L85.3986 87.5564C87.5322 86.7969 88.6462 84.4516 87.8867 82.318L71.3843 35.9589C70.6248 33.8253 68.2795 32.7114 66.1459 33.4709ZM17.9532 44.8222C12.9748 46.5944 10.3756 52.0668 12.1478 57.0453L28.6501 103.404C30.4223 108.383 35.8947 110.982 40.8732 109.21L87.2322 92.7074C92.2107 90.9352 94.8099 85.4628 93.0377 80.4844L76.5353 34.1253C74.7632 29.1469 69.2907 26.5477 64.3123 28.3198L17.9532 44.8222Z",
    fill: "#000E4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8255 66.7466C34.3192 65.3242 35.0618 63.7607 36.4842 63.2543V63.2543C37.9066 62.748 39.4702 63.4906 39.9765 64.913L42.2685 71.3518C42.7748 72.7742 42.0322 74.3378 40.6098 74.8441V74.8441C39.1874 75.3504 37.6238 74.6078 37.1175 73.1854L34.8255 66.7466Z",
    fill: "#000E4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4277 59.4261C40.9568 59.9646 40.9492 60.83 40.4108 61.3592L32.8863 68.7531C32.3479 69.2823 31.4824 69.2747 30.9533 68.7362C30.4242 68.1978 30.4317 67.3323 30.9702 66.8032L38.4947 59.4092C39.0331 58.8801 39.8986 58.8877 40.4277 59.4261Z",
    fill: "#000E4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9026 57.4637C60.3963 56.0413 61.1389 54.4777 62.5613 53.9714V53.9714C63.9838 53.4651 65.5473 54.2077 66.0536 55.6301L68.3456 62.0688C68.852 63.4913 68.1093 65.0548 66.6869 65.5611V65.5611C65.2645 66.0675 63.701 65.3249 63.1946 63.9024L60.9026 57.4637Z",
    fill: "#000E4B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1203 53.8401C56.0505 54.5918 56.6032 55.2578 57.3549 55.3276L67.8589 56.304C68.6106 56.3739 69.2766 55.8212 69.3465 55.0695C69.4164 54.3178 68.8636 53.6518 68.112 53.582L57.6079 52.6056C56.8562 52.5357 56.1902 53.0884 56.1203 53.8401Z",
    fill: "#000E4B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.074 68.5273C54.0103 68.4696 51.2164 70.1411 50.2567 70.954C49.6807 71.4419 48.8181 71.3705 48.3302 70.7945C47.8423 70.2184 47.9137 69.3559 48.4897 68.868C49.7596 67.7923 53.1777 65.7197 57.1254 65.7939C57.8802 65.8081 58.4806 66.4315 58.4664 67.1863C58.4522 67.9411 57.8288 68.5415 57.074 68.5273Z",
    fill: "#000E4B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4481 32.0587C33.7519 30.1028 34.773 27.9529 36.7288 27.2567V27.2567C38.6846 26.5605 40.8345 27.5816 41.5307 29.5375L44.2811 37.264C44.9773 39.2198 43.9562 41.3697 42.0004 42.0659V42.0659C40.0446 42.7621 37.8947 41.741 37.1985 39.7852L34.4481 32.0587Z",
    fill: "#000E4B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.679 30.2304C45.3903 29.9772 46.172 30.3485 46.4252 31.0597V31.0597C46.6784 31.7709 46.307 32.5527 45.5958 32.8059L33.3622 37.1607C32.651 37.4138 31.8692 37.0425 31.6161 36.3313V36.3313C31.3629 35.6201 31.7342 34.8383 32.4454 34.5852L44.679 30.2304Z",
    fill: "#000E4B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7396 17.0693C29.8948 18.0819 28.4095 21.209 29.4222 24.0539L29.9942 25.6608C30.6322 27.4531 31.9561 28.9185 33.6746 29.7348L36.5158 31.0842L34.1701 36.0231L31.3288 34.6736C28.3005 33.2353 25.9675 30.6528 24.8432 27.4944L24.2712 25.8875C22.2459 20.1978 25.2164 13.9436 30.906 11.9183L32.7396 17.0693Z",
    fill: "#000E4B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7396 17.0694C35.5844 16.0568 38.7115 17.542 39.7242 20.3868L40.2962 21.9937C40.9342 23.7861 40.8341 25.7584 40.0179 27.4769L38.6684 30.3182L43.6073 32.6639L44.9567 29.8227C46.3951 26.7943 46.5715 23.3186 45.4472 20.1601L44.8752 18.5532C42.8499 12.8636 36.5956 9.89308 30.906 11.9184L32.7396 17.0694Z",
    fill: "#000E4B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5894 80.9594L80.7762 67.438C66.3401 77.1058 49.8026 83.1836 32.5416 85.165L30.2319 85.4302L35.0451 98.9516L37.117 97.8218C52.2384 89.5764 68.6153 83.8793 85.5894 80.9594Z",
    fill: "#00D084"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinoTriste);
export default __webpack_public_path__ + "static/media/dinoTriste.e2949be24c73a68257c5cfcb3596908a.svg";
export { ForwardRef as ReactComponent };